import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp } from '@nu-art/thunderstorm-frontend/index';
import './PopUp_OrderGroupSelector.scss';
import { exists } from '@nu-art/ts-common';
import { Component_MetaPathwayOrder_General } from '../../components/next-steps/metapathway-order/Component_MetaPathwayOrder_General.js';
export class PopUp_OrderGroupSelector extends ComponentSync {
    static show = (e, props) => {
        // @ts-ignore - getBoundingClientRect exists on target
        const rect = e.target.getBoundingClientRect();
        const model = {
            id: 'pop-up__order-group-selector',
            modalPos: { x: 1, y: 1 },
            originPos: { x: rect.left, y: rect.bottom },
            offset: { x: 20, y: 5 },
            content: () => _jsx(PopUp_OrderGroupSelector, { ...props }),
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    //######################### Render #########################
    render() {
        return this.props.rtOrders.map(rtOrder => {
            const disabled = exists(this.state.submittingId) && this.state.submittingId !== rtOrder._id;
            return _jsx(Component_MetaPathwayOrder_General, { rtOrder: rtOrder, 
                //Empty array passed on purpose, the group renders the associated protocols, no need to show them for each rtOrder
                relatedProtocols: [], disabled: disabled, onClickPreAction: () => this.setState({ submittingId: rtOrder._id }), onClickPostAction: () => ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp) }, rtOrder._id);
        });
    }
}
//# sourceMappingURL=PopUp_OrderGroupSelector.js.map